import React, { Component } from "react";
import {
  Paper,
  Subheader,
  Divider,
  FlatButton,
  CircularProgress,
} from "material-ui";
import Formsy from "formsy-react";
import Loading from "../Loading";
import { Link } from "react-router";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Dropzone from "react-dropzone";
import addEmployeeIcon from "../../images/add_employee.png";
import downloadIcon from "../../images/download.png";
import backIcon from "../../images/back.png";

class AddEmployee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "Click to upload file, or drag and drop file",
      file: "",
      response: "",
      isLoading: false,
      company: {},
      file: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "96%",
        },
        zone: {
          width: "100%",
          height: "150px",
          border: "3px dashed red",
        },
        activeZone: {
          width: "100%",
          height: "150px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
    };

    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount() {
    console.log("params", this.props.params._id);
    this.getCompanyData(this.props.params._id);
  }

  getCompanyData(id) {
    let url = `/api/payroll/getCompany/${id}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false, company: json.company });
      });
  }

  submitForm(data) {
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url =
        "/api/payroll/uploadEmployee?companyId=" + this.props.params._id;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          this.setState({ response: json, isLoading: false });
        });
    } else {
      alert("File error");
      this.setState({ isLoading: false });
    }
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    this.setState({ file: "", response: "", isLoading: false });
  }

  onDrop(e) {
    if (e[0].name.toLowerCase().split(".")[1] === "csv") {
      this.setState({ file: e[0] });
    } else if (e[0].name) {
      this.setState({ message: `Incorrect File Type, expecting CSV` });
    } else {
      this.setState({
        message:
          "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
      });
    }
  }

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      let size = window.screen.width / 7;
      return (
        <CircularProgress
          color={this.props.appbar.color || "#424242"}
          size={size}
          thickness={20}
        />
      );
    } else if (!response) {
      return (
        <div>
          <Dropzone
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <center>
              <h4>
                {this.state.file ? this.state.file.name : this.state.message}
              </h4>
            </center>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div>
          <h4>In case of a failed upload employee list:</h4>
          <p>1. Reset form</p>
          <p>2. Upload single file</p>
          <p>3. Repeat step 1 and 2 for each upload employee list</p>
          <BootstrapTable data={response}>
            <TableHeaderColumn
              dataField="empId"
              filter={filter}
              dataSort
              isKey
              width="50"
            >
              EmpID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              width="300"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="email"
              dataSort
              filter={filter}
              width="300"
            >
              Email
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  sentFormatter(status) {
    let color;
    if (status !== "Success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  render() {
    let { centerStyle, zone, activeZone } = this.state.styles;
    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        <div className="companyListHeader">
          <Link to="/company/companyIndex">
            <div style={{ display: "inline-block" }}>
              <img
                src={backIcon}
                style={{ width: "16px", marginRight: "5px", marginTop: "-5px" }}
              />
            </div>
            <div className="companyListText">
              <div>Company List</div>
            </div>
          </Link>
        </div>
        <div style={centerStyle}>
          <div style={{ display: "inline-block" }}>
            <h1 style={{ marginBottom: "1em" }}>Import Employee</h1>
          </div>
          <div
            style={{
              display: "inline-block",
              float: "right",
              marginTop: "20px",
            }}
          >
            <Link to="/company/CompanyIndex">
              <img
                src={addEmployeeIcon}
                style={{ width: "16px", marginRight: "5px" }}
              />
              Add Employee
            </Link>
          </div>
        </div>
        <Divider />
        <br />
        <div style={centerStyle}>{this.renderContent()}</div>
        <Divider />
        <Formsy.Form
          ref="form"
          onValidSubmit={this.submitForm}
          onInvalidSubmit={this.notifyFormError}
        >
          <div>
            <div
              style={{
                display: "inline-block",
                lineHeight: "36px",
                marginTop: "1rem",
                padding: "8px",
              }}
            >
              <Link href="/api/employee_template" target="_blank">
                <img
                  src={downloadIcon}
                  style={{ width: "16px", marginRight: "5px" }}
                />
                Download Employee Template
              </Link>
            </div>
            <div
              style={{ display: "inline-block" }}
              className="footerButtonCls"
            >
              <br />
              <FlatButton
                disabled={this.state.isLoading || !!this.state.response}
                type="submit"
                label="Submit"
              />
              <FlatButton
                disabled={this.state.isLoading}
                label="reset"
                onClick={this.resetForm.bind(this)}
              />
            </div>
          </div>
        </Formsy.Form>
      </Paper>
    );
  }
}

export default AddEmployee;



// WEBPACK FOOTER //
// ./app/components/companies/AddEmployee.js